import { locationQueries, useLocations } from '@/lib/services/locations/locations.query'
import {
  stripeConnectQueries,
  useStripeConnectStatus,
} from '@/lib/services/stripe-connect/stripe-connect.query'

export function ensurePosSetupRequirements(
  queryClient,
  { organizationId, locationFilterParams } = {}
) {
  return Promise.all([
    queryClient.ensureQueryData(
      locationQueries.index({ organizationId, filters: locationFilterParams })
    ),
    queryClient.ensureQueryData(stripeConnectQueries.status({ organizationId })),
  ])
}

export function getPosSetupRequirements({ locations = [], stripeConnectStatus = null } = {}) {
  const hasLocations = locations.length > 0
  const canAcceptPayments = stripeConnectStatus?.charges_enabled === true

  return {
    hasLocations,
    canAcceptPayments,
    showLocationsCard: !hasLocations,
    showStripeCard: !canAcceptPayments,
    isReady: hasLocations && canAcceptPayments,
  }
}

export function usePosSetupRequirements({ organizationId, locationFilterParams } = {}) {
  const { data: locations = [] } = useLocations({
    organizationId,
    filters: locationFilterParams,
  })
  const { data: stripeConnectStatus } = useStripeConnectStatus({ organizationId })

  return {
    locations,
    stripeConnectStatus,
    ...getPosSetupRequirements({ locations, stripeConnectStatus }),
  }
}
